import { render, staticRenderFns } from "./SQLIframe.vue?vue&type=template&id=272917bb&"
import script from "./SQLIframe.vue?vue&type=script&lang=ts&"
export * from "./SQLIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports